/* eslint-disable */ import { EnumReflection } from '@salsita-ai/platform-project-sdk/domain';
export const ApplicationVersion = '0.0.0';
export const PublishedData = {
    type: 'object',
    properties: {
        pricing: {
            type: 'object',
            properties: {
                PricingConfig: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            data: {
                                type: 'string'
                            }
                        },
                        additionalProperties: false,
                        required: [
                            'data'
                        ]
                    }
                }
            },
            required: [],
            additionalProperties: false
        },
        presetCategories: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    description: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    img: {
                        type: 'string'
                    },
                    imgAlt: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    presets: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                configurationId: {
                                    type: 'string'
                                },
                                revisionId: {
                                    type: 'string'
                                },
                                readToken: {
                                    type: 'string'
                                },
                                name: {
                                    anyOf: [
                                        {
                                            type: 'string'
                                        },
                                        {
                                            import: [
                                                {
                                                    module: '@salsita-ai/platform-common/utils',
                                                    member: 'MultilingualString'
                                                }
                                            ],
                                            tsType: 'MultilingualString',
                                            type: 'object',
                                            properties: {
                                                $lang: {
                                                    type: 'object',
                                                    additionalProperties: {
                                                        type: 'string'
                                                    }
                                                }
                                            },
                                            required: [
                                                '$lang'
                                            ],
                                            additionalProperties: false
                                        }
                                    ]
                                },
                                description: {
                                    anyOf: [
                                        {
                                            type: 'string'
                                        },
                                        {
                                            import: [
                                                {
                                                    module: '@salsita-ai/platform-common/utils',
                                                    member: 'MultilingualString'
                                                }
                                            ],
                                            tsType: 'MultilingualString',
                                            type: 'object',
                                            properties: {
                                                $lang: {
                                                    type: 'object',
                                                    additionalProperties: {
                                                        type: 'string'
                                                    }
                                                }
                                            },
                                            required: [
                                                '$lang'
                                            ],
                                            additionalProperties: false
                                        }
                                    ]
                                },
                                img: {
                                    type: 'string'
                                },
                                imgAlt: {
                                    anyOf: [
                                        {
                                            type: 'string'
                                        },
                                        {
                                            import: [
                                                {
                                                    module: '@salsita-ai/platform-common/utils',
                                                    member: 'MultilingualString'
                                                }
                                            ],
                                            tsType: 'MultilingualString',
                                            type: 'object',
                                            properties: {
                                                $lang: {
                                                    type: 'object',
                                                    additionalProperties: {
                                                        type: 'string'
                                                    }
                                                }
                                            },
                                            required: [
                                                '$lang'
                                            ],
                                            additionalProperties: false
                                        }
                                    ]
                                },
                                detailTitle: {
                                    type: 'string'
                                },
                                detailDescription: {
                                    type: 'string'
                                },
                                tags: {
                                    type: 'array',
                                    items: {
                                        type: 'string'
                                    }
                                }
                            },
                            required: [
                                'configurationId',
                                'revisionId',
                                'readToken',
                                'name',
                                'description'
                            ],
                            additionalProperties: false
                        }
                    }
                },
                required: [
                    'id',
                    'name',
                    'presets'
                ],
                additionalProperties: false
            }
        },
        recipes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    description: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    collection: {
                        type: 'string'
                    },
                    configuration: {
                        type: 'object',
                        properties: {
                            modelVersion: {
                                type: 'number'
                            },
                            entities: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        id: {
                                            type: 'string'
                                        },
                                        type: {
                                            type: 'string'
                                        }
                                    },
                                    required: [
                                        'id',
                                        'type'
                                    ],
                                    additionalProperties: true
                                }
                            },
                            rootEntityType: {
                                type: 'string'
                            },
                            recipeIds: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        },
                        required: [
                            'modelVersion',
                            'entities',
                            'rootEntityType',
                            'recipeIds'
                        ],
                        additionalProperties: false
                    }
                },
                required: [
                    'id',
                    'name',
                    'description',
                    'collection',
                    'configuration'
                ],
                additionalProperties: false
            }
        },
        system: {
            type: 'object',
            properties: {
                presetCategories: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'string'
                            },
                            name: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        import: [
                                            {
                                                module: '@salsita-ai/platform-common/utils',
                                                member: 'MultilingualString'
                                            }
                                        ],
                                        tsType: 'MultilingualString',
                                        type: 'object',
                                        properties: {
                                            $lang: {
                                                type: 'object',
                                                additionalProperties: {
                                                    type: 'string'
                                                }
                                            }
                                        },
                                        required: [
                                            '$lang'
                                        ],
                                        additionalProperties: false
                                    }
                                ]
                            },
                            description: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        import: [
                                            {
                                                module: '@salsita-ai/platform-common/utils',
                                                member: 'MultilingualString'
                                            }
                                        ],
                                        tsType: 'MultilingualString',
                                        type: 'object',
                                        properties: {
                                            $lang: {
                                                type: 'object',
                                                additionalProperties: {
                                                    type: 'string'
                                                }
                                            }
                                        },
                                        required: [
                                            '$lang'
                                        ],
                                        additionalProperties: false
                                    }
                                ]
                            },
                            img: {
                                type: 'string'
                            },
                            imgAlt: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        import: [
                                            {
                                                module: '@salsita-ai/platform-common/utils',
                                                member: 'MultilingualString'
                                            }
                                        ],
                                        tsType: 'MultilingualString',
                                        type: 'object',
                                        properties: {
                                            $lang: {
                                                type: 'object',
                                                additionalProperties: {
                                                    type: 'string'
                                                }
                                            }
                                        },
                                        required: [
                                            '$lang'
                                        ],
                                        additionalProperties: false
                                    }
                                ]
                            },
                            presets: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        configurationId: {
                                            type: 'string'
                                        },
                                        revisionId: {
                                            type: 'string'
                                        },
                                        readToken: {
                                            type: 'string'
                                        },
                                        name: {
                                            anyOf: [
                                                {
                                                    type: 'string'
                                                },
                                                {
                                                    import: [
                                                        {
                                                            module: '@salsita-ai/platform-common/utils',
                                                            member: 'MultilingualString'
                                                        }
                                                    ],
                                                    tsType: 'MultilingualString',
                                                    type: 'object',
                                                    properties: {
                                                        $lang: {
                                                            type: 'object',
                                                            additionalProperties: {
                                                                type: 'string'
                                                            }
                                                        }
                                                    },
                                                    required: [
                                                        '$lang'
                                                    ],
                                                    additionalProperties: false
                                                }
                                            ]
                                        },
                                        description: {
                                            anyOf: [
                                                {
                                                    type: 'string'
                                                },
                                                {
                                                    import: [
                                                        {
                                                            module: '@salsita-ai/platform-common/utils',
                                                            member: 'MultilingualString'
                                                        }
                                                    ],
                                                    tsType: 'MultilingualString',
                                                    type: 'object',
                                                    properties: {
                                                        $lang: {
                                                            type: 'object',
                                                            additionalProperties: {
                                                                type: 'string'
                                                            }
                                                        }
                                                    },
                                                    required: [
                                                        '$lang'
                                                    ],
                                                    additionalProperties: false
                                                }
                                            ]
                                        },
                                        img: {
                                            type: 'string'
                                        },
                                        imgAlt: {
                                            anyOf: [
                                                {
                                                    type: 'string'
                                                },
                                                {
                                                    import: [
                                                        {
                                                            module: '@salsita-ai/platform-common/utils',
                                                            member: 'MultilingualString'
                                                        }
                                                    ],
                                                    tsType: 'MultilingualString',
                                                    type: 'object',
                                                    properties: {
                                                        $lang: {
                                                            type: 'object',
                                                            additionalProperties: {
                                                                type: 'string'
                                                            }
                                                        }
                                                    },
                                                    required: [
                                                        '$lang'
                                                    ],
                                                    additionalProperties: false
                                                }
                                            ]
                                        },
                                        detailTitle: {
                                            type: 'string'
                                        },
                                        detailDescription: {
                                            type: 'string'
                                        },
                                        tags: {
                                            type: 'array',
                                            items: {
                                                type: 'string'
                                            }
                                        }
                                    },
                                    required: [
                                        'configurationId',
                                        'revisionId',
                                        'readToken',
                                        'name',
                                        'description'
                                    ],
                                    additionalProperties: false
                                }
                            }
                        },
                        required: [
                            'id',
                            'name',
                            'presets'
                        ],
                        additionalProperties: false
                    }
                },
                recipes: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'string'
                            },
                            name: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        import: [
                                            {
                                                module: '@salsita-ai/platform-common/utils',
                                                member: 'MultilingualString'
                                            }
                                        ],
                                        tsType: 'MultilingualString',
                                        type: 'object',
                                        properties: {
                                            $lang: {
                                                type: 'object',
                                                additionalProperties: {
                                                    type: 'string'
                                                }
                                            }
                                        },
                                        required: [
                                            '$lang'
                                        ],
                                        additionalProperties: false
                                    }
                                ]
                            },
                            description: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        import: [
                                            {
                                                module: '@salsita-ai/platform-common/utils',
                                                member: 'MultilingualString'
                                            }
                                        ],
                                        tsType: 'MultilingualString',
                                        type: 'object',
                                        properties: {
                                            $lang: {
                                                type: 'object',
                                                additionalProperties: {
                                                    type: 'string'
                                                }
                                            }
                                        },
                                        required: [
                                            '$lang'
                                        ],
                                        additionalProperties: false
                                    }
                                ]
                            },
                            collection: {
                                type: 'string'
                            },
                            configuration: {
                                type: 'object',
                                properties: {
                                    modelVersion: {
                                        type: 'number'
                                    },
                                    entities: {
                                        type: 'array',
                                        items: {
                                            type: 'object',
                                            properties: {
                                                id: {
                                                    type: 'string'
                                                },
                                                type: {
                                                    type: 'string'
                                                }
                                            },
                                            required: [
                                                'id',
                                                'type'
                                            ],
                                            additionalProperties: true
                                        }
                                    },
                                    rootEntityType: {
                                        type: 'string'
                                    },
                                    recipeIds: {
                                        type: 'array',
                                        items: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    'modelVersion',
                                    'entities',
                                    'rootEntityType',
                                    'recipeIds'
                                ],
                                additionalProperties: false
                            }
                        },
                        required: [
                            'id',
                            'name',
                            'description',
                            'collection',
                            'configuration'
                        ],
                        additionalProperties: false
                    }
                }
            },
            required: [],
            additionalProperties: false
        }
    },
    required: [],
    additionalProperties: false
};
export const PublishedDataHash = 'acab1c64e135';
export const SessionData = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        accessToken: {
            type: 'string'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        emailAddress: {
            type: 'string'
        },
        fullName: {
            type: 'string',
            nullable: true
        }
    },
    required: [],
    additionalProperties: false
};
export const FrontendData = {};
export const FinalizeData = {
    type: 'object',
    properties: {
        addToCart: {
            type: 'boolean'
        },
        emailAddress: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        phoneNumber: {
            type: 'string'
        },
        message: {
            type: 'string'
        },
        submissionDate: {
            type: 'string'
        }
    },
    required: [
        'addToCart',
        'emailAddress',
        'firstName',
        'lastName'
    ],
    additionalProperties: false
};
export const PrefetchedFinalizeData = {};
export const FinalizeResult = {
    type: 'object',
    properties: {
        pdfLink: {
            type: 'string'
        },
        clientGeneratedImageLink: {
            type: 'string'
        },
        shopifyProduct: {
            type: 'object',
            properties: {
                success: {
                    type: 'boolean'
                },
                productId: {
                    type: 'number'
                },
                productTitle: {
                    type: 'string'
                },
                productUrl: {
                    type: 'string'
                },
                productVariantId: {
                    type: 'number'
                },
                sku: {
                    type: 'string'
                },
                price: {
                    type: 'string'
                },
                message: {
                    type: 'string'
                },
                error: {
                    type: 'string'
                }
            },
            additionalProperties: false
        }
    },
    required: [],
    additionalProperties: false
};
export const CallbackData = {
    type: 'object',
    properties: {
        customProduct: {
            type: 'object',
            properties: {
                title: {
                    type: 'string'
                },
                description: {
                    type: 'string'
                },
                price: {
                    type: 'number'
                }
            },
            required: [
                'title',
                'description',
                'price'
            ],
            additionalProperties: false
        }
    },
    required: [],
    additionalProperties: false
};
export const BackendData = undefined;
export const NavigationState = new EnumReflection('NavigationState', {
    enum: [
        'Shape',
        'Base',
        'Wood',
        'Appearance',
        'Accessories',
        'Summary',
        'FinalizeQuote',
        'FinalizeCart'
    ]
});
export const ViewState = new EnumReflection('ViewState', {
    enum: [
        'Default'
    ]
});
export const ToolState = new EnumReflection('ToolState', {
    enum: [
        'Default'
    ]
});
export const ExportState = new EnumReflection('ExportState', {
    enum: [
        'Default',
        'Thumbnail'
    ]
});
export const AdminNavigationState = new EnumReflection('AdminNavigationState', {
    enum: [
        'PresetCategories',
        'Presets',
        'Pricing'
    ]
});
export const AdminViewState = new EnumReflection('AdminViewState', {
    enum: [
        'Default'
    ]
});
export const $dataSpec = {
    custom: {
        PricingConfig: {
            definition: {
                data: 'string'
            },
            chunk: 'pricing',
            kind: 'manual'
        }
    },
    swatchOptions: {}
};
export const $adminPagesSpec = {
    presets: true,
    pages: [
        {
            key: 'pricing',
            title: 'Pricing',
            icon: 'TagBold',
            navigationState: 'Pricing',
            component: 'PricingPage',
            actionsComponent: 'PricingActions'
        }
    ]
};

//# sourceMappingURL=application-types.js.map